export const SET_QR_LIST = 'dt/rq-codes/SET_QR_LIST';
export const SET_CUTTING_LINES = 'dt/qr-codes/SET_CUTTING_LINES';
export const SET_ELEMS_IN_ROW = 'dt/qr-codes/SET_ELEMS_IN_ROW';
export const SET_SCAN_FOR_PAGE = 'dt/qr-codes/SET_SCAN_FOR_PAGE';
export const CLEAR_SELECTED_QRS = 'dt/qr-codes/CLEAR_SELECTED_QRS';

export const setSelectedQRS = (selectedQRS) => ({
  type: SET_QR_LIST,
  selectedQRS,
});

export const setCuttingLines = (cuttingLinesShown) => ({
  type: SET_CUTTING_LINES,
  cuttingLinesShown,
});

export const setScanForPage = (scanForPageId, scanForPagePath) => ({
  type: SET_SCAN_FOR_PAGE,
  scanForPageId,
  scanForPagePath,
});

export const setElemsInRow = (elemsInRow) => ({
  type: SET_ELEMS_IN_ROW,
  elemsInRow,
});
